var KeyboardKey = /*#__PURE__*/function (KeyboardKey) {
  KeyboardKey["Escape"] = "Escape";
  KeyboardKey["Tab"] = "Tab";
  KeyboardKey["Enter"] = "Enter";
  KeyboardKey["Space"] = " ";
  KeyboardKey["ArrowDown"] = "ArrowDown";
  KeyboardKey["ArrowUp"] = "ArrowUp";
  KeyboardKey["ArrowLeft"] = "ArrowLeft";
  KeyboardKey["ArrowRight"] = "ArrowRight";
  KeyboardKey["Left"] = "Left";
  KeyboardKey["Right"] = "Right";
  KeyboardKey["Backspace"] = "Backspace";
  return KeyboardKey;
}({});

export { KeyboardKey };
//# sourceMappingURL=keyboard.js.map
